var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIconModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 12.2444,
    cy: 12.0001,
    rx: 12.2444,
    ry: 12.0001,
    transform: "matrix(0.999771 -0.0214075 0.0222884 0.999752 0.695312 1)",
    fill: "#D4BBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36373 8.00013C9.24743 8.00013 9.13099 8.04443 9.04236 8.13329L8.13329 9.04236C7.95557 9.22008 7.95557 9.50783 8.13329 9.6851L11.4482 13L8.13329 16.3149C7.95557 16.4926 7.95557 16.7804 8.13329 16.9576L9.04236 17.8667C9.22008 18.0444 9.50783 18.0444 9.6851 17.8667L13 14.5518L16.3149 17.8667C16.4922 18.0444 16.7804 18.0444 16.9576 17.8667L17.8667 16.9576C18.0444 16.7799 18.0444 16.4922 17.8667 16.3149L14.5518 13L17.8667 9.6851C18.0444 9.50783 18.0444 9.21963 17.8667 9.04236L16.9576 8.13329C16.7799 7.95557 16.4922 7.95557 16.3149 8.13329L13 11.4482L9.6851 8.13329C9.59624 8.04443 9.48003 8.00013 9.36373 8.00013Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconModal);
export default __webpack_public_path__ + "static/media/crossIconModal.9c987ba5f069c26ac10ca844e153d593.svg";
export { ForwardRef as ReactComponent };